//import * as React from "react";
import React, { useRef, useEffect, useState } from "react";

import './styles.css';
import validacion from "components/nubox/NuInput/validacion"
//import Errors from "../Errors";
//import Icon from "../Icon";
//--- pueden ser varias piezas 2,5,4
const PatternValidation = (valor, tipo) => {
  const regex = new RegExp('^[0-9]*([,][0-9]+)*$');    
  return regex.test(valor);
};
//-----------------------------------------------------------------------
const NuInput = ({ 
  
  className,
  containerStyle,
  errors,
  disabled,
  icon,
  inputStyle,
  name,
  onChange,
  placeholder,
  readOnly,
  required,
  type,
  value,
  wrapperStyle,
  valtipo='',
  classError='is-invalid',
  autoComplete="off",
}) => {
  const inputRef = React.useRef(null);

  const [cad_error,setCadError] = React.useState(""); //cadena de errro
  //const classRequired = ref("")
  /*useEffect(() => {
    className = "appointment-item " + (selected ? "selected" : "");
    console.log(className );
  }, [selected] );*/
  //-------------------------------------------
  const handleClick = () => {
    if (inputRef && inputRef.current) inputRef.current.focus();
  };
  //-------------------------------------------
  const handleChange = (e) => {
    //---- lo validamos
    //---si es correcto retorna cadena vacia
    //---sino, retorna el error
    let cad = validacion(e.target.value, valtipo );
    setCadError(cad);
    //-----------pintamos si corresponde
    /*if(cad!==""){
      classError="is-invalid";
    }*/
    //---llamamos al obChange del padre
    onChange(e);
  };

  return (
    <div className={""} style={wrapperStyle}>
      {
       //JSON.stringify(required) 
       //JSON.stringify(value==="") 
       //JSON.stringify(cad_error==="") 
       //JSON.stringify(classError==="") 
       //className= {` ${className} ${cad_error==="" ? '': classError} ${required===false? '': classError} ` }
       }
      
      <div onClick={handleClick} className="" style={containerStyle}>
        <input
          ref={inputRef}
          //aria-label={name}
          //data-testid={name}
          tabIndex={0}
          type={type}
          name={name}
          onChange={handleChange}
          placeholder={placeholder}
          value={value}
          style={inputStyle}
          disabled={disabled}
          readOnly={readOnly}
          className= {` ${className} ${cad_error==="" ? '': classError} ` }
          valtipo={valtipo}
          autoComplete={autoComplete}
        />
      </div>
      { value==="" && required && (
        <div ><span className="text-danger">.</span></div>
      )}
      { cad_error!=='' &&
        <div className="text-danger">{ cad_error }</div>  
      }
    </div>
  );
};


export default NuInput;
